import { render } from "./RejectPermissionComponent.vue?vue&type=template&id=3f8a5a4a&scoped=true&lang=true"
import script from "./RejectPermissionComponent.vue?vue&type=script&lang=js"
export * from "./RejectPermissionComponent.vue?vue&type=script&lang=js"

import "./RejectPermissionComponent.vue?vue&type=style&index=0&id=3f8a5a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8a5a4a"]])

export default __exports__